/* ============================================================
   JMO /challenge page — brand injection
   ============================================================
   Shopify's bot-verification redirect lands the customer on a generic
   .shopify-challenge__container with just "let us know you're not a robot."
   This script prepends our own branded heading, icon, and a "Cancel and go
   back" link, so the redirect feels like a continuation of the JMO flow
   instead of a system error. Only runs when the challenge container is
   present in the DOM — no-op on every other page.

   Companion CSS lives in jmo.css under the
   "Shopify /challenge page — branded styling" section.
   ============================================================ */
(function () {
  if (window.__jmoChallengeBrandInit) return;
  window.__jmoChallengeBrandInit = true;

  function brand() {
    var container = document.querySelector('.shopify-challenge__container');
    if (!container) return;
    // Already branded? bail (defends against script being included twice)
    if (container.querySelector('.jmo-challenge-brand')) return;

    // Pull the original return_path off the URL so the "Cancel" link can point
    // back to wherever the customer was when they submitted the quote.
    var params = new URLSearchParams(window.location.search);
    var returnPath = params.get('return_path') || '/';
    // Sanitize — only allow same-origin paths.
    // Defense-in-depth against open-redirect / scheme-injection if Shopify (or a
    // future Shopify plan change) ever stops controlling this URL strictly.
    // The regex requires:
    //   - leading `/`
    //   - followed by a character that is NOT `/` or `\` (blocks `//evil.com`
    //     protocol-relative redirects AND `/\evil.com` backslash-normalization
    //     bypasses that some browsers historically allowed)
    // Any failure → fall back to homepage.
    if (!/^\/[^/\\]/.test(returnPath)) {
      returnPath = '/';
    }

    // Build the branded wrapper. We use innerHTML for compactness; the SVG
    // is a hand-rolled inline icon (no dependency on the {% render 'jmo-icon' %}
    // snippet since we're outside the Liquid render pipeline).
    var brandHTML =
      '<div class="jmo-challenge-brand">' +
        '<div class="jmo-challenge-brand__icon" aria-hidden="true">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" ' +
            'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>' +
            '<path d="m9 12 2 2 4-4"/>' +
          '</svg>' +
        '</div>' +
        '<h1 class="jmo-challenge-brand__title">Quick verification</h1>' +
        '<p class="jmo-challenge-brand__lede">' +
          'We just need to confirm you’re a real person before submitting your form. ' +
          'Complete the check below and we’ll take you right back.' +
        '</p>' +
      '</div>';

    container.insertAdjacentHTML('afterbegin', brandHTML);

    // Append a "Cancel and go back" link at the bottom of the container.
    // The ?jmo_quote_cancel=1 marker signals jmo-quote.js to wipe the just-submitted
    // session flag on the next page load so we don't falsely show the success card.
    var cancelSeparator = returnPath.indexOf('?') === -1 ? '?' : '&';
    var backHTML =
      '<p class="jmo-challenge-back">' +
        '<a href="' + returnPath + cancelSeparator + 'jmo_quote_cancel=1">← Cancel and go back</a>' +
      '</p>';
    container.insertAdjacentHTML('beforeend', backHTML);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', brand);
  } else {
    brand();
  }
})();
